import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import Asset from '@/types/table/asset';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface AssetData extends Asset {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class AssetController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<AssetData>>(API_CONTEXT + '/asset/asset/list', params, httpOptions);
  }
  static myList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<AssetData>>(
      API_CONTEXT + '/asset/asset/myList',
      params,
      httpOptions,
    );
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<AssetData>(API_CONTEXT + '/asset/asset/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/asset/asset/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/asset/asset/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/asset/asset/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/asset/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/asset/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/asset/delete', params, httpOptions);
  }
  static grant(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/asset/grant', params, httpOptions);
  }
  static maintenance(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/asset/maintenance', params, httpOptions);
  }
  static maintenanceStore(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/asset/maintenanceStore', params, httpOptions);
  }
  static depreciation(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/asset/depreciation', params, httpOptions);
  }
  static repay(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/asset/repay', params, httpOptions);
  }
  static scrap(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/asset/scrap', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/asset/deleteBatch', params, httpOptions);
  }
}
